import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../../layouts/full-layout/breadcrumb/Breadcrumb";
import { Alert, Box, Button, Card, Stack } from "@mui/material";
import FeatherIcon from "feather-icons-react";
import { getAddNewQuestionObj } from "./EmptyAddNewQuestion";
import { Form, FormikProvider, useFormik } from "formik";
import { AddQuestion } from "./AddQuestion";
import QuestionValidation from "../../../../validationSchema/Question";
import {
  AddorEditQuestion,
  GetAllQuestionCategories,
  GetQuestionById,
} from "../../../../services/human-resource";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router";
import ImageModal from "../../../../components/forms/image-popover-modal/ImageModal";
import { routes } from "../../../../routes/routes";

const Create = () => {
  const [selectQuestion, setSelectQuestion] = useState(getAddNewQuestionObj());
  const [questionCategories, setQuestionCategories] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [img, setImg] = useState();
  const { id } = useParams();
  const location = useLocation();
  const questionid = id ? id : null;
  const view = location?.pathname?.includes("/question-view");
  const navigate = useNavigate();
  useEffect(() => {
    GetQuestionCategories();
    if (id) {
      getQuestionById();
    }
  }, []);

  const BCrumb = [
    {
      to: "/",
      title: "HR Management",
    },
    {
      title: `${questionid ? (view ? "View" : "Edit") : "Add"} Question`,
    },
  ];
  const getQuestionById = async () => {
    try {
      const response = await GetQuestionById(questionid);
      if (response?.status === 200) {
        const questionData = response?.data;

        const [option1, option2, option3, option4] =
          questionData.optionValues || [];

        setSelectQuestion({
          ...questionData,
          option1: option1 || "",
          option2: option2 || "",
          option3: option3 || "",
          option4: option4 || "",
        });
      }
    } catch (e) {}
  };
  const GetQuestionCategories = async () => {
    try {
      const response = await GetAllQuestionCategories();
      if (response?.status === 200) {
        setQuestionCategories(response?.data);
      }
    } catch (e) {}
  };
  const formik = useFormik({
    initialValues: selectQuestion,
    onSubmit(values, { resetForm }) {
      addQuestion(values, resetForm);
    },
    enableReinitialize: true,
    validationSchema: QuestionValidation,
  });
  const addQuestion = async (values, resetForm) => {
    const optionsString = [
      values?.option1,
      values?.option2,
      values?.option3,
      values?.option4,
    ]
      .filter((option) => option)
      .join(",");
    const formData = new FormData();
    if (questionid) {
      formData.append("id", questionid);
    }
    formData.append("questionCategoriesId", values?.questionCategoriesId);
    if (values?.questionCategoriesId === 1) {
      formData.append("questionTypesId", 1);
    }
    formData.append("questionTypesId", 2);
    formData.append("name", values?.question);
    formData.append("options", optionsString);
    formData.append("answer", values?.answer);
    formData.append("Image", values?.attachment);

    try {
      const response = await AddorEditQuestion(formData);

      if (response?.status === 200) {
        const message = questionid
          ? "Question Updated Successfully"
          : "Question Added Successfully";

        toast.success(message);

        if (questionid) {
          navigate(routes?.allQuestionlist.match);
        }

        resetForm();
      }
    } catch (error) {
      console.error("Error while adding/editing question:", error);
    }
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenModal = (row) => {
    setOpenModal(true);
    setImg(row);
  };
  const { handleChange, setFieldValue, values } = formik;

  return (
    <>
      <Breadcrumb
        title={`${questionid ? (view ? "View" : "Edit") : "Add"} Question`}
        items={BCrumb}
      />
      <Card
        sx={{
          p: 0,
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          p={2}
          sx={{
            backgroundColor: "primary.light",
            color: "primary.main",
          }}
        >
          <FeatherIcon icon="alert-circle" width="18" />
          <Box sx={{ ml: 1 }}>{`${
            questionid ? (view ? "View" : "Edit") : "Add"
          } Question`}</Box>
        </Box>

        <Box style={{ padding: "10px" }}>
          <Stack spacing={1}>
            {formik.touched.questionCategoriesId &&
              formik.errors.questionCategoriesId && (
                <Alert variant="filled" severity="error">
                  {formik.touched.questionCategoriesId &&
                    formik.errors.questionCategoriesId}
                </Alert>
              )}
            {formik.touched.question && formik.errors.question && (
              <Alert variant="filled" severity="error">
                {formik.touched.question && formik.errors.question}
              </Alert>
            )}

            {formik.touched.option1 && formik.errors.option1 && (
              <Alert variant="filled" severity="error">
                {formik.touched.option1 && formik.errors.option1}
              </Alert>
            )}
            {formik.touched.option2 && formik.errors.option2 && (
              <Alert variant="filled" severity="error">
                {formik.touched.option2 && formik.errors.option2}
              </Alert>
            )}
            {formik.touched.answer && formik.errors.answer && (
              <Alert variant="filled" severity="error">
                {formik.touched.answer && formik.errors.answer}
              </Alert>
            )}
            {formik.touched.image && formik.errors.image && (
              <Alert variant="filled" severity="error">
                {formik.touched.image && formik.errors.image}
              </Alert>
            )}
          </Stack>
        </Box>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Box sx={{ width: "100%", typography: "body1" }}>
              <Card>
                <AddQuestion
                  values={values}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  questionCategories={questionCategories}
                  view={view}
                  handleOpenModal={handleOpenModal}
                />
              </Card>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
              {questionid && (
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ marginRight: "20px" }}
                  onClick={() => {
                    navigate(routes?.allQuestionlist.match);
                  }}
                >
                  Back to List
                </Button>
              )}
              {!view && (
                <Button variant="contained" color="primary" type="submit">
                  {`${questionid ? (view ? "View" : "Edit") : "Add"} Question`}
                </Button>
              )}
            </Box>
          </Form>
        </FormikProvider>
      </Card>
      <ImageModal
        openModal={openModal}
        img={img}
        setOpenModal={setOpenModal}
        handleCloseModal={handleCloseModal}
      />
    </>
  );
};

export default Create;
